import * as React from 'react';

export const SkeletonLoader: React.FC = () => {
  return (
    <div className="copilot-skeleton-loader">
      <div className="copilot-skeleton-line copilot-skeleton-line--long" />
      <div className="copilot-skeleton-line copilot-skeleton-line--medium" />
      <div className="copilot-skeleton-line copilot-skeleton-line--short" />
    </div>
  );
};
